<div class="dialog-container">
  <div class="header">
    <span class="title">{{
      loginRole === "teacher"
        ? "Send event details to student"
        : "Send event details to teacher"
    }}</span>
    <button class="close-btn" (click)="onCancel()">
      <img src="assets/images/cross-icon.svg" alt="Close" />
    </button>
  </div>

  <form [formGroup]="form" class="content">
    <div class="d-grid gap-2">
      <div class="d-flex align-items-center justify-content-between wrap-claas">
        <span class="input-label"> Event invitation link </span>
        <span class="copy-link" (click)="copyEventLink()">
          <img src="assets/images/link-angled-blue.svg" alt="Close" /> Copy
          event invitation link
        </span>
      </div>
      <div class="form-control">
        <img src="assets/images/link-angled.svg" class="link-icon" alt="link" />
        <input
          type="text"
          formControlName="eventLink"
          placeholder="Event invitation link"
          readonly
        />
      </div>
    </div>

    <div class="d-grid gap-2 mt-4">
      <div class="d-flex align-items-center justify-content-between wrap-claas">
        <span class="input-label"> Email preview </span>
        <span class="copy-link" (click)="copyEmailTemplate()">
          <img src="assets/images/link-angled-blue.svg" alt="Close" /> Copy
          email template with link
        </span>
      </div>

      <!-- Text Editor Section -->
      <div
        class="text-editor-container"
        [ngClass]="{ 'show-height': studentShare }"
      >
        <div
          class="editor-content"
          contenteditable="true"
          (input)="onEditorInput($event)"
          (blur)="onEditorBlur()"
          placeholder="Email template will appear here..."
          #emailEditor
        ></div>
      </div>
    </div>

    <div class="form-group" *ngIf="!this.studentShare">
      <label for="email">Email</label>
      <div class="input-container email-multi-input">
        <img src="assets/images/sms.svg" alt="email icon" class="icon" />
        <div class="email-chips-container">
          <div *ngFor="let email of emailsList" class="email-chip">
            <span>{{ email }}</span>
            <button
              type="button"
              class="remove-chip"
              (click)="removeEmail(email)"
            >
              ×
            </button>
          </div>
          <input
            id="email"
            type="email"
            [formControl]="emailInputControl"
            placeholder="Enter teacher's email"
            (keydown.enter)="addEmail()"
            (blur)="addEmailOnBlur()"
            (keydown)="handleKeyDown($event)"
            (input)="onEmailInput($event)"
          />
        </div>
      </div>
      <div class="login-error-message-container" *ngIf="showEmailError">
        <div class="login-error-message">
          {{ emailErrorMessage }}
        </div>
      </div>
      <div class="normal-text">
        Type an email and press Enter to add multiple recipients.
      </div>
    </div>
  </form>
  <div class="actions">
    <button type="button" class="btn btn-secondary" (click)="onCancel()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="loading"
      (click)="onSend()"
      *ngIf="!this.studentShare"
    >
      {{ loading ? "Sending..." : "Send" }}
    </button>
  </div>
</div>
